<template>
  <div class="dashboard-page1">
    <!-- 顶部用户信息栏 -->
    <div class="top-bar">
      <div class="user-info">
        <!-- 头像上传容器 -->
        <div class="avatar-upload-container" @click="triggerAvatarUpload">
          <img :src="userInfo.userAvatar || 'http://49.232.163.2:5159/image/30.png'" alt="用户头像" class="avatar">
          <!-- 上传遮罩层 -->
        </div>
        <!-- 隐藏的文件上传输入框 -->
        <input type="file" ref="avatarInput" class="avatar-input" accept="image/*" @change="handleAvatarChange">
        <div class="user-meta">
          <div class="user-name">{{ userInfo.userName }}</div>
          <div class="user-stat">{{ userInfo.briefIntroduction }}</div>
        </div>
      </div>
      <div class="finance-info">
        <!-- <div class="finance-item">
          <div class="item-value">{{ userInfo.awaitPayment }}</div>
          <div class="item-label">待结算(元)</div>
        </div> -->
        <div class="finance-item">
          <div class="item-value">{{ userInfo.withdrawCash }}</div>
          <div class="item-label">可提现(元)</div>
        </div>
        <button class="withdraw-btn" @click="goWithDraw()">提现</button>
      </div>
    </div>

    <!-- 数据区域 -->
    <div class="data-section">
      <!-- 交易数据卡片 -->
      <div class="data-card">
        <!-- <div class="merchant-level">
          <span class="level-tag">商户等级 ({{ orderSummary.growthValue || 0 }}/{{ orderSummary.userLevel || 0 }})</span>
        </div> -->
        <div class="sales-amount">
          <div class="amount-value">{{ orderSummary.salesRevenue }}</div>
          <div class="amount-label">销售额 (元)</div>
        </div>
        <div class="data-grid">
          <div class="data-item">
            <div class="item-label">销售量 (笔)</div>
            <div class="item-value">{{ orderSummary.salesVolume }}</div>
          </div>
          <div class="data-item">
            <div class="item-label">点击量</div>
            <div class="item-value">{{ orderSummary.clickThrough }}</div>
          </div>
          <div class="data-item">
            <div class="item-label">发布数</div>
            <div class="item-value">{{ orderSummary.publishVolume }}</div>
          </div>
          <div class="data-item">
            <div class="item-label">访客数 (人次)</div>
            <div class="item-value">{{ orderSummary.visitorCount }}</div>
          </div>
          <div class="data-item">
            <div class="item-label">销售排行 (名)</div>
            <div class="item-value">{{ orderSummary.salesRanking }}<span class="new-tag">较前日↑0</span></div>
          </div>
        </div>
      </div>

      <!-- 趋势图表区域 -->
      <div class="chart-section">
        <div class="chart-header">
          <div class="chart-title">最近30天趋势</div>
          <div class="chart-tabs">
            <button class="chart-tab" :class="{ active: activeTab === 'sales' }"
              @click="switchTab('sales')">销售额</button>
            <button class="chart-tab" :class="{ active: activeTab === 'volume' }"
              @click="switchTab('volume')">销售量</button>
          </div>
        </div>
        <div class="chart-container">
          <!-- 真实数据渲染的图表 -->
          <div class="chart-content" v-if="orderDetails.length > 0">
            <!-- 提示框 -->
            <div class="tooltip" v-if="hoverData.show" :style="{
              top: `${hoverData.top}px`,
              left: `${hoverData.left}px`
            }">
              {{ hoverData.date }}<br>
              <span v-if="activeTab === 'sales'">销售额:{{ hoverData.value }}云币</span>
              <span v-else>销售量:{{ hoverData.value }}</span>
            </div>

            <!-- 折线容器 - 使用SVG绘制折线 -->
            <div class="chart-line-container">
              <!-- 水平线参考 -->
              <div class="chart-grid"></div>

              <!-- SVG折线图 -->
              <svg class="chart-svg" width="100%" height="100%">
                <!-- 折线路径 -->
                <path :d="getLinePath()" stroke="#ffb042" stroke-width="2" fill="none" />
              </svg>

              <!-- 数据圆点 -->
              <div class="chart-point" v-for="(item, index) in orderDetails" :key="index"
                :style="getPointPosition(item, index)" @mouseenter="showTooltip(item, index, $event)"
                @mouseleave="hideTooltip()"></div>
            </div>

            <!-- 日期标签 -->
            <div class="chart-dates">
              <div class="date-label" v-for="(item, index) in orderDetails" :key="`date-${index}`"
                :style="{ left: `${index * (100 / (orderDetails.length - 1))}%` }">
                <!-- {{ formatDate(item.date) }} -->
              </div>
            </div>
          </div>
          <!-- 空数据提示 -->
          <div class="chart-empty" v-else>
            暂无数据
          </div>
        </div>
      </div>
    </div>

    <!-- 内容概况区域 -->
    <div class="content-overview">
      <div class="overview-title">
        <i class="overview-icon"></i>
        内容概况
      </div>
      <div class="overview-cards">
        <div class="overview-card">
          <div class="card-value">{{ contentInfo.waiting }}</div>
          <div class="card-label">待售后</div>
          <img src="../../../assets/dashboard/1.png">
        </div>
        <div class="overview-card">
          <div class="card-value">{{ contentInfo.violationReminder }}</div>
          <div class="card-label">违规提醒</div>
          <img src="../../../assets/dashboard/2.png">
        </div>
        <div class="overview-card">
          <div class="card-value">{{ contentInfo.notpassed }}</div>
          <div class="card-label">未通过</div>
          <img src="../../../assets/dashboard/3.png">
        </div>
        <div class="overview-card">
          <div class="card-value">{{ contentInfo.pendingreview }}</div>
          <div class="card-label">待审核</div>
          <img src="../../../assets/dashboard/4.png">
        </div>
        <div class="overview-card">
          <div class="card-value">{{ contentInfo.listed }}</div>
          <div class="card-label">已上架</div>
          <img src="../../../assets/dashboard/5.png">
        </div>
      </div>
    </div>

    <!-- 实名认证弹窗 -->
    <div class="auth-modal" v-if="showAuthModal">
      <div class="auth-modal-content">
        <h3 class="auth-modal-title">实名认证提醒</h3>
        <p class="auth-modal-desc">
          您尚未完成实名认证，请先完善实名认证信息。<br>
          完成后，您的作品将可正常进行商用授权及结算。<br>
          如有疑问，欢迎随时联系我们。
        </p>
        <button class="auth-modal-btn" @click="goToAuthPage">去完善</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DashboardPage',
  data() {
    return {
      // 订单汇总数据
      orderSummary: {
        id: "",
        salesRevenue: "",
        salesVolume: "",
        clickThrough: "",
        orderVolume: "",
        publishVolume: "",
        visitorCount: "",
        salesRanking: "",
        growthValue: "",
        userLevel: ""
      },
      // 近30天明细数据
      orderDetails: [],
      // 用户信息
      userInfo: {},
      // 内容概况
      contentInfo: {},
      // 激活的标签页
      activeTab: 'sales',
      // 最大值（用于计算比例）
      maxValue: 0,
      // 悬停提示数据
      hoverData: {
        show: false,
        date: '',
        value: '',
        top: 0,
        left: 0
      },
      // 实名认证弹窗显示状态
      showAuthModal: false
    };
  },
  async mounted() {
    // 优先等待认证状态查询完成
    await this.checkAuthStatus();

    // 再加载其他数据（可选：如果其他接口也需要等认证结果，就放这里）
    this.fetchOrderSummary();
    this.fetchOrderDetails();
    this.UserHomepage();
    this.ContentOverview();
  },
  methods: {
    // 查询认证状态
    async checkAuthStatus() {
      try {
        const res = await this.$apiFun.getSeleMerchantCA();
        if (res.status === 200) {
          this.showAuthModal = !res.obj.merchantCA;
        } else {
          this.showAuthModal = true;
          this.$message.error("认证状态查询失败");
        }
      } catch (err) {
        this.showAuthModal = true;
        this.$message.error('认证状态查询失败');
        console.error('查询认证状态出错：', err);
      }
    },
    // 跳转到实名认证页面
    goToAuthPage() {
      // 这里替换为实际的实名认证页面路由
      this.$router.push('/dashboard/seller/info');
      this.showAuthModal = false;
    },
    // 跳转到提现页面
    goWithDraw() {
      // 未认证时拦截提现操作
      if (this.showAuthModal) {
        this.$message.warning('请先完成实名认证');
        return;
      }
      this.$router.push('/dashboard/seller/withdraw');
    },

    // 切换选项卡
    switchTab(tab) {
      this.activeTab = tab;
      // 重新计算最大值
      this.calculateMaxValue();
    },

    // 计算最大值
    calculateMaxValue() {
      if (!this.orderDetails || this.orderDetails.length === 0) {
        this.maxValue = 0;
        return;
      }

      // 根据当前标签页获取对应字段的最大值
      if (this.activeTab === 'sales') {
        this.maxValue = Math.max(...this.orderDetails.map(item => Number(item.totalAmount) || 0));
      } else {
        this.maxValue = Math.max(...this.orderDetails.map(item => Number(item.salesVolume) || 0));
      }

      // 防止最大值为0导致除零错误
      if (this.maxValue === 0) {
        this.maxValue = 1;
      }
    },

    // 获取圆点位置
    getPointPosition(item, index) {
      const chartHeight = 180;
      const containerWidth = document.querySelector('.chart-line-container')?.offsetWidth || 800;
      const value = this.activeTab === 'sales'
        ? Number(item.totalAmount) || 0
        : Number(item.salesVolume) || 0;

      // 【关键】折线和圆点共用同一套坐标计算
      const y = chartHeight - (value / this.maxValue) * chartHeight;
      const x = (containerWidth / (this.orderDetails.length - 1)) * index;

      return {
        top: `${y}px`,     // 直接使用折线的Y坐标
        left: `${x}px`,    // 直接使用折线的X坐标
        transform: 'translate(-50%, -50%)' // 确保圆点中心与坐标点完全重合
      };
    },

    // 生成SVG折线路径
    getLinePath() {
      if (!this.orderDetails || this.orderDetails.length === 0) return '';

      const chartHeight = 180;
      const containerWidth = document.querySelector('.chart-line-container')?.offsetWidth || 800;
      const pointCount = this.orderDetails.length;
      let path = '';

      this.orderDetails.forEach((item, index) => {
        const value = this.activeTab === 'sales'
          ? Number(item.totalAmount) || 0
          : Number(item.salesVolume) || 0;

        // 折线坐标与圆点坐标完全一致
        const y = chartHeight - (value / this.maxValue) * chartHeight;
        const x = (containerWidth / (pointCount - 1)) * index;

        if (index === 0) {
          path += `M ${x} ${y}`;
        } else {
          path += ` L ${x} ${y}`;
        }
      });

      return path;
    },

    // 显示提示框
    showTooltip(item, index, event) {
      const value = this.activeTab === 'sales'
        ? Number(item.totalAmount).toFixed(2)
        : Number(item.salesVolume);

      // 获取圆点位置
      const pointPosition = this.getPointPosition(item, index);
      const pointLeft = parseFloat(pointPosition.left);
      const pointTop = parseFloat(pointPosition.top);

      // 设置提示框数据
      this.hoverData = {
        show: true,
        date: item.date,
        value: value,
        // 提示框位置（圆点上方10px）
        top: pointTop - 60,
        left: pointLeft - 35
      };
    },

    // 隐藏提示框
    hideTooltip() {
      this.hoverData.show = false;
    },

    // 格式化日期（只显示月-日）
    formatDate(dateStr) {
      if (!dateStr) return '';
      const date = new Date(dateStr);
      return `${date.getMonth() + 1}-${date.getDate()}`;
    },

    // 获取订单汇总数据
    fetchOrderSummary() {
      this.$apiFun.getOrderSummary()
        .then(res => {
          if (res.status === 200 || res.code === 200) {
            this.orderSummary = res.obj || res.data || {};
          }
        })
        .catch(err => {
          console.error('订单数据加载失败:', err);
          this.$message?.error('订单数据加载失败，请稍后重试');
        });
    },

    // 获取近30天明细数据
    fetchOrderDetails() {
      this.$apiFun.getOrderDetails()
        .then(res => {
          if (res.status === 200 || res.code === 200) {
            this.orderDetails = res.obj || res.data || [];
            // 计算最大值
            this.calculateMaxValue();
          }
        })
        .catch(err => {
          console.error('近30天数据加载失败:', err);
          this.$message?.error('近30天数据加载失败，请稍后重试');
        });
    },

    // 获取用户主页信息
    UserHomepage() {
      this.$apiFun.getSellerHomepage()
        .then(res => {
          if (res.status === 200) {
            this.userInfo = res.obj;
          }
        })
        .catch(err => {
          console.error('商户信息加载失败:', err);
          this.$message?.error('商户信息加载失败，请稍后重试');
        });
    },

    // 获取内容概况
    ContentOverview() {
      this.$apiFun.getContentOverview()
        .then(res => {
          if (res.status === 200) {
            this.contentInfo = res.obj;
          }
        })
        .catch(err => {
          console.error('商户内容概况加载失败:', err);
          this.$message?.error('商户内容概况加载失败，请稍后重试');
        });
    },

    // ========== 新增头像上传相关方法 ==========
    // 触发头像上传选择框
    triggerAvatarUpload() {
      this.$refs.avatarInput.click();
    },

    // 处理头像文件选择
    handleAvatarChange(e) {
      const file = e.target.files[0];
      if (!file) return;

      // 校验文件类型和大小
      const isImage = file.type.startsWith('image/');
      const isLt2M = file.size / 1024 / 1024 < 5;

      if (!isImage) {
        this.$message?.error('请选择图片格式的文件！');
        return;
      }

      if (!isLt2M) {
        this.$message?.error('头像图片大小不能超过5MB！');
        return;
      }

      // 创建FormData对象
      const formData = new FormData();
      formData.append('file', file);

      // 调用上传头像接口
      this.uploadAvatar(formData);
    },

    // 上传头像接口调用
    uploadAvatar(formData) {
      this.$apiFun.postUploadAvatar(formData)
        .then(res => {
          if (res.status == 200) {
            // 上传成功，更新头像显示
            this.userInfo.userAvatar = res.obj || res.data;
            this.$message?.success('头像上传成功！');
            this.UserHomepage();
            // 清空文件输入框
            this.$refs.avatarInput.value = '';
          } else {
            this.$message?.error('头像上传失败：' + (res.msg || '服务器错误'));
          }
        })
        .catch(err => {
          console.error('头像上传失败:', err);
          this.$message?.error('头像上传失败，请稍后重试');

          // 清空文件输入框
          this.$refs.avatarInput.value = '';
        });
    }
  }
};
</script>

<style lang="less" scoped>
// 深色主题变量
@bg-primary: transparent;
@bg-secondary: rgba(0,0,0,.2);
@bg-tertiary: #3a3a3a;
@text-primary: #e0e0e0;
@text-secondary: #a0a0a0;
@accent-red: #0ea5e9;
@accent-yellow: #ffb042;
@border-color: #444;

.dashboard-page1 {
  background-color: @bg-primary;
  color: @text-primary;
  min-height: 100vh;
  padding: 20px;
  box-sizing: border-box;
  position: relative; // 为弹窗添加定位容器

  // 实名认证弹窗样式
  .auth-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;

    .auth-modal-content {
      background-color: @bg-secondary;
      border-radius: 8px;
      width: 400px;
      padding: 30px 20px;
      text-align: center;

      .auth-modal-title {
        font-size: 20px;
        color: @text-primary;
        margin-bottom: 15px;
        font-weight: 500;
      }

      .auth-modal-desc {
        font-size: 14px;
        color: @text-secondary;
        line-height: 1.8;
        margin-bottom: 20px;
      }

      .auth-modal-btn {
        background-color: #0ea5e9;
        color: #fff;
        border: none;
        padding: 10px 20px;
        border-radius: 4px;
        font-size: 16px;
        cursor: pointer;
        width: 100%;
        max-width: 200px;
      }
    }
  }

  // 顶部用户信息栏
  .top-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: @bg-secondary;
    border-radius: 6px;
    padding: 20px;
    margin-bottom: 15px;
    position: relative; // 修复vip-prompt定位

    .user-info {
      display: flex;
      align-items: center;

      // 新增头像上传容器样式
      .avatar-upload-container {
        position: relative;
        width: 80px;
        height: 80px;
        border-radius: 10%;
        overflow: hidden;
        margin-right: 15px;
        cursor: pointer;

        // 头像样式
        .avatar {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: all 0.3s ease;
        }

        // 上传遮罩层
        .avatar-upload-mask {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: rgba(0, 0, 0, 0.5);
          display: flex;
          align-items: center;
          justify-content: center;
          opacity: 0;
          transition: opacity 0.3s ease;

          .upload-icon {
            color: #fff;
          }
        }

        // hover效果
        &:hover {
          .avatar {
            filter: brightness(0.8);
          }

          .avatar-upload-mask {
            opacity: 1;
          }
        }
      }

      // 隐藏的文件输入框
      .avatar-input {
        display: none;
      }

      .user-meta {
        .user-name {
          font-size: 20px;
          font-weight: 500;
          margin-bottom: 5px;
        }

        .user-stat {
          font-size: 13px;
          color: @text-secondary;
          margin-bottom: 3px;
        }
      }
    }

    .finance-info {
      display: flex;
      gap: 20px;
      align-items: center;

      .finance-item {
        text-align: right;

        .item-value {
          font-size: 24px;
          color: @accent-red;
          margin-bottom: 5px;
        }

        .item-label {
          font-size: 13px;
          color: @text-secondary;
        }
      }

      .withdraw-btn {
        background-color: @accent-red;
        color: #fff;
        border: none;
        padding: 8px 15px;
        border-radius: 4px;
        cursor: pointer;
        font-size: 14px;
      }
    }

    .vip-prompt {
      position: absolute;
      top: 20px;
      right: 20px;
      font-size: 13px;
      color: @text-secondary;

      .sign-btn {
        background-color: transparent;
        border: 1px solid @accent-yellow;
        color: @accent-yellow;
        padding: 3px 8px;
        border-radius: 3px;
        cursor: pointer;
        font-size: 12px;
        margin-left: 5px;
      }
    }
  }

  // 数据区域
  .data-section {
    display: flex;
    gap: 20px;
    margin-bottom: 20px;

    // 交易数据卡片
    .data-card {
      flex: 1;
      background-color: @bg-secondary;
      border-radius: 6px;
      padding: 20px;
      box-sizing: border-box;

      .merchant-level {
        margin-bottom: 15px;

        .level-tag {
          display: inline-block;
          background-color: #333;
          color: @text-secondary;
          font-size: 13px;
          padding: 3px 8px;
          border-radius: 3px;
        }
      }

      .sales-amount {
        margin-bottom: 20px;

        .amount-value {
          font-size: 36px;
          color: @text-primary;
          margin-bottom: 5px;
        }

        .amount-label {
          font-size: 14px;
          color: @text-secondary;
        }
      }

      .data-grid {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 15px;

        .data-item {
          background-color: @bg-primary;
          border-radius: 4px;
          padding: 10px;

          .item-label {
            font-size: 13px;
            color: @text-secondary;
            margin-bottom: 5px;
          }

          .item-value {
            font-size: 16px;
            color: @text-primary;
          }

          .new-tag {
            font-size: 12px;
            color: @accent-red;
            margin-left: 3px;
          }
        }
      }
    }

    // 趋势图表区域
    .chart-section {
      flex: 2;
      background-color: @bg-secondary;
      border-radius: 6px;
      padding: 20px;
      box-sizing: border-box;

      .chart-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 15px;

        .chart-title {
          font-size: 18px;
          font-weight: 500;
        }

        .chart-tabs {
          display: flex;
          gap: 5px;

          .chart-tab {
            background-color: @bg-primary;
            border: none;
            color: @text-secondary;
            padding: 6px 12px;
            border-radius: 4px;
            cursor: pointer;
            font-size: 13px;

            &.active {
              background-color: @accent-yellow;
              color: #000;
              font-weight: 500;
            }
          }
        }
      }

      .chart-container {
        position: relative;
        height: 220px;
        background-color: @bg-primary;
        border-radius: 4px;
        padding: 20px;
        box-sizing: border-box;

        // 空数据提示
        .chart-empty {
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: @text-secondary;
          font-size: 14px;
        }

        // 图表内容
        .chart-content {
          width: 100%;
          height: 100%;
          position: relative;

          // 提示框
          .tooltip {
            position: absolute;
            background-color: rgba(0, 0, 0, 0.8);
            color: #fff;
            padding: 8px 12px;
            border-radius: 4px;
            font-size: 12px;
            z-index: 100;
            pointer-events: none;
            white-space: nowrap;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
          }

          // 折线容器
          .chart-line-container {
            width: 100%;
            height: 180px;
            position: relative;
            margin-bottom: 10px;

            // 网格线
            .chart-grid {
              width: 100%;
              height: 100%;
              background-image: linear-gradient(to top, rgba(255, 255, 255, 0.1) 1px, transparent 1px);
              background-size: 100% 25%;
              position: absolute;
              top: 0;
              left: 0;
              z-index: 0;
            }

            // SVG折线图容器
            .chart-svg {
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              z-index: 1;
            }

            // 数据圆点
            .chart-point {
              position: absolute;
              width: 8px;
              height: 8px;
              border-radius: 10%;
              background-color: @accent-yellow;
              z-index: 2;
              cursor: pointer;
              transition: all 0.2s;

              &:hover {
                transform: translate(-50%, 50%) scale(1.5);
                box-shadow: 0 0 8px @accent-yellow;
              }
            }
          }

          // 日期标签
          .chart-dates {
            width: 100%;
            display: flex;
            justify-content: space-between;
            position: absolute;
            bottom: 0;
            left: 0;

            .date-label {
              font-size: 11px;
              color: @text-secondary;
              position: absolute;
              transform: translateX(-50%);
            }
          }
        }
      }
    }
  }

  // 内容概况区域
  .content-overview {
    background-color: @bg-secondary;
    border-radius: 6px;
    padding: 20px;
    box-sizing: border-box;

    .overview-title {
      display: flex;
      align-items: center;
      font-size: 18px;
      font-weight: 500;
      margin-bottom: 15px;

      .overview-icon {
        width: 20px;
        height: 20px;
        background: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024"><path fill="%23ff4d4f" d="M128 128c-35.3 0-64 28.7-64 64v640c0 35.3 28.7 64 64 64h768c35.3 0 64-28.7 64-64V192c0-35.3-28.7-64-64-64H128zm0 64h768v512H128V192zm64 256c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm320 0c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm320 0c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64z"/></svg>') no-repeat center;
        margin-right: 10px;
      }
    }

    .overview-cards {
      display: flex;
      gap: 15px;

      .overview-card {
        flex: 1;
        background-color: @bg-primary;
        border-radius: 4px;
        padding: 15px;
        box-sizing: border-box;
        text-align: center;

        .card-value {
          font-size: 24px;
          color: @text-primary;
          margin-bottom: 5px;
        }

        .card-label {
          font-size: 14px;
          color: @text-secondary;
          margin-bottom: 10px;
        }
      }
    }
  }
}
</style>